import { SYNC_BROADCAST_SETTINGS } from '../../Types';

export default updates => {
  return dispatch => {
    const action = {
      type: SYNC_BROADCAST_SETTINGS,
      payload: updates
    };

    dispatch(action);
  };
};
